import React from "react"
import { Helmet } from "react-helmet-async"
import { Award, Users, Heart, Truck } from "lucide-react"

const About: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Anmol Furniture Bazar</title>
        <meta 
          name="description" 
          content="Learn about Anmol Furniture Bazar - Your trusted partner for premium furniture in Virar East, Thane. Quality furniture, excellent service since decades." 
        />
      </Helmet>

      <div className="min-h-screen bg-gray-50 py-12">
        <div className="container mx-auto px-4">
          {/* Header Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">About Anmol Furniture Bazar</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Your trusted partner for premium furniture, creating beautiful spaces that inspire and comfort for over a decade.
            </p>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
            <div className="space-y-6">
              <h2 className="text-3xl font-semibold text-gray-900">Our Story</h2>
              <p className="text-gray-700 leading-relaxed">
                Established with a vision to transform homes across Maharashtra, Anmol Furniture Bazar has been 
                serving customers in Virar East, Thane, and surrounding areas with exceptional furniture solutions. 
                We believe that every home deserves beautiful, functional, and durable furniture.
              </p>
              <p className="text-gray-700 leading-relaxed">
                From humble beginnings to becoming a trusted name in furniture retail, we've maintained our 
                commitment to quality, affordability, and customer satisfaction. Our extensive collection ranges 
                from modern sofas to traditional wardrobes, ensuring something perfect for every home.
              </p>
            </div>

            <div className="space-y-6">
              <h2 className="text-3xl font-semibold text-gray-900">Our Mission</h2>
              <p className="text-gray-700 leading-relaxed">
                To provide high-quality furniture at affordable prices while delivering exceptional customer 
                service. We aim to make beautiful home furnishing accessible to everyone, helping families 
                create spaces they love.
              </p>
              
              <div className="bg-white p-6 rounded-xl shadow-lg">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Why Choose Us?</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-primary-600 rounded-full"></div>
                    <span>Premium quality furniture at competitive prices</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-primary-600 rounded-full"></div>
                    <span>Wide range of styles and designs</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-primary-600 rounded-full"></div>
                    <span>Expert guidance and personalized service</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-primary-600 rounded-full"></div>
                    <span>Hassle-free delivery and installation</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <Award className="w-12 h-12 text-primary-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Quality Assured</h3>
              <p className="text-gray-600">Premium materials and craftsmanship in every piece</p>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <Users className="w-12 h-12 text-primary-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Expert Team</h3>
              <p className="text-gray-600">Experienced professionals to guide your choices</p>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <Heart className="w-12 h-12 text-primary-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Customer Care</h3>
              <p className="text-gray-600">Dedicated support for complete satisfaction</p>
            </div>

            <div className="text-center p-6 bg-white rounded-xl shadow-lg">
              <Truck className="w-12 h-12 text-primary-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Fast Delivery</h3>
              <p className="text-gray-600">Quick and safe delivery to your doorstep</p>
            </div>
          </div>

          {/* Location Info */}
          <div className="mt-16 text-center bg-white p-8 rounded-xl shadow-lg">
            <h2 className="text-3xl font-semibold text-gray-900 mb-6">Visit Our Showroom</h2>
            <div className="max-w-2xl mx-auto">
              <p className="text-lg text-gray-700 mb-4">
                Experience our furniture collection in person at our spacious showroom in Virar East, Thane.
              </p>
              <div className="text-gray-600 space-y-2">
                <p className="font-semibold">Address:</p>
                <p>Anmol Furniture Bazar</p>
                <p>Virar East, Thane, Maharashtra 401305</p>
                <p className="mt-4">
                  <span className="font-semibold">Business Hours:</span><br />
                  Mon - Sat: 9:00 AM - 8:00 PM<br />
                  Sunday: 10:00 AM - 6:00 PM
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default About